import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.555 11.61a2.558 2.558 0 1 1-5.116 0 2.558 2.558 0 0 1 5.116 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.133 11.055a1 1 0 0 0 0 1.11l1.543 2.314c3.958 5.937 12.683 5.937 16.64 0l1.543-2.314a1 1 0 0 0 0-1.11l-1.542-2.313c-3.958-5.938-12.683-5.938-16.641 0zm9.863 4.392a3.837 3.837 0 1 0 0-7.674 3.837 3.837 0 0 0 0 7.674",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }